module.exports = __webpack_public_path__ + "static/media/CBO - Community based organization Mobile 22-02-2024 C.5b2c2413.gif";